module.exports = __webpack_public_path__ + "img/switch_img1_msg3.277c8692.png";